import { AfterViewInit, DestroyRef, Directive, ElementRef, Input, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Direction, Directionality } from '@angular/cdk/bidi';
import { SwiperOptions } from 'swiper/types';
import { SwiperContainer } from 'swiper/element';

@Directive({
  selector: '[appSwiper]',
  standalone: true,
})
export class SwiperDirective implements AfterViewInit {

  @Input() config?: SwiperOptions;

  private readonly swiperElement: SwiperContainer;
  private readonly directionality = inject(Directionality);
  private readonly destroyRef = inject(DestroyRef);

  constructor(private el: ElementRef<HTMLElement>) {
    this.swiperElement = el.nativeElement as SwiperContainer;
  }

  ngAfterViewInit() {
    Object.assign(this.swiperElement, this.config);
    this.swiperElement.initialize();

    this.applyDirection(this.directionality.value);
    this.directionality.change
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(dir => this.applyDirection(dir));
  }

  private applyDirection(dir: Direction): void {
    const swiper = this.swiperElement.swiper;
    if (!swiper || swiper.rtlTranslate === (dir === 'rtl')) return;

    swiper.slides.forEach(slide => {
      slide.style.marginLeft = '';
      slide.style.marginRight = '';
    });
    swiper.changeLanguageDirection(dir);
  }
}
